videoPlayerHeartsVisible